export abstract class AbstractService  {
    async init() {

    };
}